/**
 * Created by v-grfore on 22/01/2017.
 */
import * as React from 'react';
import {WbsComponentData} from './WbsComponent'
import {CssClassAndIdNames, Names} from "../CssClassAndIdNames";

/**
 * WbsEdge data needed
 */
export interface PropsWbsEdge {
    edgeId: string;
    sourceWbsComponentData: WbsComponentData;
    targetWbsComponentData: WbsComponentData;
}

/**
 * Connector coordinates
 */
export interface ConnectorPoint {
    x: number;
    y: number;
}

export interface EdgeData {
    data: {
        id: string;
        source: string;
        target: string;
    }
}

export interface EdgesData extends Array<EdgeData> {}

export interface StateWbsEdge {}

export class WbsEdge extends React.Component<PropsWbsEdge, StateWbsEdge>{

    public static LEAVING_CONNECTOR_OFFSET: number = 10;

    constructor(props: PropsWbsEdge) {
        super(props); //this creates the react component
        // now we extend it if needed
        this.getPath = this.getPath.bind(this);
    }

    /**
     * Calculate the coordinates of the source Edge connector
     * @returns {{x: number, y: number}}
     */
    private sourceEdgeConnectorPoint(): ConnectorPoint {
        let y: number = this.props.sourceWbsComponentData.y + this.props.sourceWbsComponentData.height;
        if (this.props.sourceWbsComponentData.layoutStyle == 0) {
            return {
                x: this.props.sourceWbsComponentData.x + this.props.sourceWbsComponentData.width / 2,
                y: y
            };
        } else {
            return {
                x: this.props.sourceWbsComponentData.x + WbsEdge.LEAVING_CONNECTOR_OFFSET,
                y: y
            };
        }
    }

    /**
     * Calculate the coordinates of the target Edge connector
     * @returns {{x: number, y: number}}
     */
    private targetEdgeConnectorPoint(): ConnectorPoint {
        if (this.props.sourceWbsComponentData.layoutStyle == 0) {
            return {
                x: this.props.targetWbsComponentData.x + this.props.targetWbsComponentData.width / 2,
                y: this.props.targetWbsComponentData.y
            };
        } else {
            return {
                x: this.props.targetWbsComponentData.x,
                y: this.props.targetWbsComponentData.y + this.props.targetWbsComponentData.height / 2
            };
        }
    }

    /**
     * @property {number} xSource The x coordinate of the Source GraphNode.
     * @returns {number}
     */
    public get xSource(): number { return this.sourceEdgeConnectorPoint().x; }

    /**
     * @property {number} ySource The y coordinate of the Source GraphNode.
     * @returns {number}
     */
    public get ySource(): number { return this.sourceEdgeConnectorPoint().y; }

    /**
     * @property {number} xTarget The x coordinate of the Target GraphNode.
     * @returns {number}
     */
    public get xTarget(): number { return this.targetEdgeConnectorPoint().x; }

    /**
     * @property {number} yTarget The y coordinate of the Target GraphNode.
     * @returns {number}
     */
    public get yTarget(): number { return this.targetEdgeConnectorPoint().y; }

    /**
     * Defines the SVG path between from the fromNode to the endNode.
     * @returns {string} The SVG path
     */
    private getPath(): string {
        let connectorPath: string;
        // let cornerRadius: number = 4;
        //
        // if (this.props.sourceWbsComponentData.layoutStyle != 0) {
        //     connectorPath = 'M' + this.xSource + ' ' + this.ySource + ' V' + (this.yTarget - cornerRadius ) + 'A' + cornerRadius + ',' + cornerRadius + ' 0 0,0 ' + (this.xTarget - cornerRadius * 2) + ',' + this.yTarget + ' H' + this.xTarget;
        // } else {
        //     let elbowY = this.ySource + (this.yTarget - this.ySource) * .7; // .7 allows to lower the elbow. 0.5 would leave it in the middle of the connector
        //     if (this.xSource < this.xTarget) {
        //         connectorPath = 'M' + this.xSource + ' ' + this.ySource + ' V' + elbowY + ' H' + (this.xTarget - cornerRadius) + 'A' + cornerRadius + ',' + cornerRadius + ' 0 0,1 ' + this.xTarget + ',' + (this.yTarget - cornerRadius) + ' V' + this.yTarget;
        //     } else{
        //         connectorPath = 'M' + this.xSource + ' ' + this.ySource + ' V' + elbowY + ' H' + (this.xTarget + cornerRadius) + 'A' + cornerRadius + ',' + cornerRadius + ' 0 0,0 ' + this.xTarget + ',' + (this.yTarget - cornerRadius) + ' V' + this.yTarget;
        //     }
        // }

        if (this.props.sourceWbsComponentData.layoutStyle != 0) {
            connectorPath = 'M' + this.xSource + ' ' + this.ySource + ' V' + this.yTarget + ' H' + this.xTarget;
        } else {
            let elbowY = this.yTarget - 10;
            //let elbowY = this.ySource + (this.yTarget - this.ySource) * .7; // .7 allows to lower the elbow. 0.5 would leave it in the middle of the connector
            connectorPath = 'M' + this.xSource + ' ' + this.ySource + ' V' + elbowY + ' H' + this.xTarget + ' V' + this.yTarget;
        }

        return connectorPath;
    }

    public render() {
        const className = CssClassAndIdNames.getClassName(Names.WbsEdge);
        const id = CssClassAndIdNames.getIdName(Names.WbsEdge, this.props.edgeId);
        return (
            <path
                className={className}
                id={id}
                d={this.getPath()}>
            </path>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/WbsEdge.tsx